import { State } from '@progress/kendo-data-query';
import { ILocationsStatistic, ILookupValue } from '../../model';
import { getApi, isApiCancel } from './api';
import { GridDataResult } from '../../model/api/nexParkInstance/lotDirectory';
import { BillableStatus, BulkSetLotBillableStatusRequest } from './nexParkInstance';
import { NexResponsePriceMode } from '../../model/api/locations/NexResponsePriceMode';

const URL = '/nexResponse';

const getRegionLookupValues = async (): Promise<ILookupValue[]> => {
  const api = await getApi();
  return api.get<ILookupValue[]>(`${URL}/regions`).then((response) => response.data || []);
};

export const getLocationsList = async (customerId: number, regionId: number, state: State): Promise<GridDataResult> => {
  const params = {
    group: state.group,
    filter: state.filter,
    skip: state.skip,
    limit: state.take,
    sort: state.sort,
  };

  try {
    const api = await getApi();
    const response = await api.post<GridDataResult>(`${URL}/customers/${customerId}/regions/${regionId}/lots`, params);
    return response.data || [];
  } catch (error) {
    console.error('Error fetching locations list:', error);
    throw error;
  }
};

export const getLocationsStatistic = async (customerId: number, regionId: number, signal?: AbortSignal): Promise<ILocationsStatistic> => {
  try {
    const api = await getApi();
    const response = await api.get<ILocationsStatistic>(`${URL}/customers/${customerId}/regions/${regionId}/lots/statistic`, { signal });
    return response.data;
  } catch (error) {
    if (!isApiCancel(error)) {
      console.error('Error fetching NexResponse locations statistic:', error);
    }
    throw error;
  }
};

export const setLotBillableStatus = async (customerId: number, request: BillableStatus) => {
  try {
    const api = await getApi();
    await api.put(`${URL}/customers/${customerId}/lots/billable-status`, request);
  } catch (error) {
    console.error(`Error setting billable status for lot ${request.lotId}:`, error);
    throw error;
  }
};

export const bulkSetLotBillableStatus = async (customerId: number, request: BulkSetLotBillableStatusRequest) => {
  try {
    const api = await getApi();
    await api.put(`${URL}/customers/${customerId}/lots/bulk/billable-status`, request);
  } catch (error) {
    console.error(`Error during bulk update of billable statuses:`, error);
    throw error;
  }
};

export const setLotPriceModelStatus = async (customerId: number, lotId: number, priceMode: NexResponsePriceMode) => {
  const params = {
    LotId: lotId,
    PriceMode: priceMode,
  };

  try {
    const api = await getApi();
    await api.put(`${URL}/${customerId}/lots/nexresponse/pricemode`, params);
  } catch (error) {
    console.error(`Error setting price category for lot ${lotId}:`, error);
    throw error;
  }
};

export const bulkSetLotPriceModelStatus = async (customerId: number, lotIds: number[], priceMode: NexResponsePriceMode) => {
  const params = {
    LotIds: lotIds,
    PriceMode: priceMode,
  };

  try {
    const api = await getApi();
    await api.put(`${URL}/${customerId}/lots/bulk/nexresponse/pricemode`, params);
  } catch (error) {
    console.error(`Error setting price category:`, error);
    throw error;
  }
};

export const nexResponseService = {
  getRegionLookupValues,
  getLocationsList,
  getLocationsStatistic,
  setLotBillableStatus,
  bulkSetLotBillableStatus,
  setLotPriceModelStatus,
  bulkSetLotPriceModelStatus,
};
